import { render } from "./FieldsBuilder.vue?vue&type=template&id=32fef15a"
import script from "./FieldsBuilder.vue?vue&type=script&lang=js"
export * from "./FieldsBuilder.vue?vue&type=script&lang=js"

import exportComponent from "/trc/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__